import React, { Component } from 'react';
import { formatGenericError } from 'app/utils/errors';
import { notify } from 'app/services/errorReporter';
import { useSetHttpStatus } from 'app/utils/HttpStatusState';

interface IProps {
  children: React.ReactNode;
}

interface IState {
  error: undefined | Error;
}

export default class FallbackErrorBoundary extends Component<IProps, IState> {
  public constructor(props: IProps) {
    super(props);

    this.state = {
      error: undefined,
    };
  }

  public componentDidCatch(error: Error, info: React.ErrorInfo) {
    notify(error, { name: 'FallbackErrorBoundary', context: { info } });
    this.setState({ error });
  }

  public render() {
    const { error } = this.state;

    if (error !== undefined) {
      return <FallbackMessage error={error} />;
    } else {
      return this.props.children;
    }
  }
}

export function FallbackMessage({ error }: { error: Error }) {
  try {
    useSetHttpStatus(500);
  } catch (e) {
    // Ignore errors here, because this is the final fallback and we really
    // want this to still work even if nothing else does.
  }

  // Note: This intentionally does not use i18n, so it is as robust as possible.
  return (
    <div>
      <p>There was an unknown error. Please refresh and try again.</p>

      <p>{formatGenericError(error)}</p>

      <pre>{error && error.stack}</pre>
    </div>
  );
}
